import React, { useState, useEffect, useContext } from 'react';
import { withStyles } from '@material-ui/core';
import { openLink } from '../util/utilNative';
import DataContext from '../data/DataContext';

const styles = (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.color.background,
  },
  loading: {
    width: '60px',
    height: '12px',
  },
});

function NaverMaps(props) {
  const {
    classes,
    id,
    style,
    title,
    latitude,
    longitude,
    defaultZoom,
    countryCode,
    lotype,
  } = props;
  const [navermap, setNavermap] = useState(null);

  let random = Math.random().toString(36).substring(7);
  const divId = id + random;
  const context = useContext(DataContext);
  console.log(
    `id: ${id} [${lotype}] title:${title} - latitude(${latitude}), longitude(${longitude})`
  );

  useEffect(() => {
    console.log(
      `[NaverMaps] useEffect : id: ${id} [${lotype}] title:${title} - latitude(${latitude}), longitude(${longitude})`
    );
    try {
      if (navermap) {
        console.log(`[NaverMaps] destroy previous map object`);
        navermap.destroy();
      }
    } catch (e) {
      console.log(e);
    }
    // if (window.naver.maps && navermap === null) {
    if (window.naver.maps) {
      console.log('[NaverMaps] create new map object');
      var navermaps = window.naver.maps;
      var position = new navermaps.LatLng(latitude, longitude);
      var mapOptions = {
        center: position,
        zoom: defaultZoom,
        scaleControl: false,
        logoControl: false,
        mapDataControl: false,
        zoomControl: false,
        mapTypeControl: false,
      };

      try {
        var map = new navermaps.Map(divId, mapOptions);
        new navermaps.Marker({
          position: position,
          title: title,
          map: map,
        });

        function openNaverMaps() {
          var url = `${window.location.href}ext/maps/NaverMaps.html?country=${countryCode}&title=${title}&lng=${longitude}&lat=${latitude}`;
          openLink(context, 'inapp', url);
        }

        // navermaps.Event.addListener(map, 'click', function () {
        //   var url = `${window.location.href}ext/maps/NaverMaps.html?country=${countryCode}&title=${title}&lng=${longitude}&lat=${latitude}`;
        //   openLink(context, 'inapp', url);
        // });

        navermaps.Event.addListener(map, 'click', openNaverMaps);

        let target = document.querySelector(`#${divId}`);
        target.addEventListener('keydown', function (e) {
          // console.log('e.key ::::::::::::', e.key);

          if (e.key === 'Enter') {
            openNaverMaps();
          }
        });

        setNavermap(map);
      } catch (e) {
        console.log('error', e);
      }
    }

    return () => {
      if (navermap) {
        navermap.destroy();
      }
    };
  }, [latitude, longitude]);

  return (
    <div
      id={divId}
      style={style}
      className={classes.root}
      tabIndex={0}
      role={'link'}
      aria-label={`${context.string.aria.navermap}, 마커의 위경도는 ${latitude}, ${longitude}`}
    />
  );
}
export default React.memo(withStyles(styles)(NaverMaps));
